import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { registerSurveyHost, type SurveyHost } from './host'

const SurveyHome = lazy(() => import('./components'))
const SurveyRecordCreate = lazy(() => import('./components/Survey/Create'))
const SurveyRecordDetail = lazy(() => import('./components/Survey/Detail'))

const SurveyModule: RouteObject = {
    path: 'surveys',
    children: [
        {
            path: '',
            element: <SurveyHome />,
        },
        // {
        //     path: 'new',
        //     element: <SurveyCreate />,
        // },
        {
            path: 'records/new',
            element: <SurveyRecordCreate />,
        },
        // {
        //     path: ':surveyId',
        //     element: <SurveyDetail />,
        // },
        {
            path: 'records/:recordId',
            element: <SurveyRecordDetail />,
        },
        // {
        //     path: ':surveyId/edit',
        //     element: <SurveyEdit />,
        // },
    ],
}

/**
 * The Survey route, for the host to mount (it adds the errorElement).
 *
 * This is the only way to get it, and it takes the host: so a host cannot
 * mount the route and forget to register the pieces it reads at render time.
 * Registering also adds the `surveys` i18n namespace.
 */
export function createSurveyModule(host: SurveyHost): RouteObject {
    registerSurveyHost(host)
    return SurveyModule
}

export type { SurveyHost } from './host'
